import { GetServerSidePropsContext } from 'next';
import { Environment } from 'models/Environment';
import { Keyword } from 'models/Keyword';
import { TargetMarket } from 'models/TargetMarket';
import { determineKeywordApiUrl } from './urls';
import { ShopSearchRawQueryParams } from 'models/ShopSearchRawQueryParams';
import { normalizeShopSearchRawQuery } from './normalizeShopSearchRawQuery';
import { STATUS_CODES } from './statusCodes';

export async function getKeywordsOfCategory(
  context: GetServerSidePropsContext,
  environment: Environment,
  targetMarket: TargetMarket
): Promise<Keyword[]> {
  const query = normalizeShopSearchRawQuery(
    context.query as ShopSearchRawQueryParams
  );

  if (query.q || !query.category) {
    return [];
  }

  const url = new URL(determineKeywordApiUrl(environment));
  url.searchParams.append('category', query.category);
  url.searchParams.append('targetMarket', targetMarket);

  const response: Response = await fetch(url.toString());

  if (!response.ok && response.status === STATUS_CODES.NOT_FOUND) {
    throw STATUS_CODES.GONE;
  }

  return await response.json();
}
